import './styles.scss';

import React, {CSSProperties, HTMLAttributeAnchorTarget, PropsWithChildren} from 'react';

import { addStateHistory } from '../../../utils/StateHistoryUtil';

interface AppLinkProps extends PropsWithChildren {
    href?: string;
    style?: CSSProperties;
    target?: HTMLAttributeAnchorTarget | undefined;
    action:string;
    onClick?: () => void;
}

export const AppLink = ({href, style, target, children, onClick, action, ...rest}: AppLinkProps) => {

    const onClickWrapper = () => {
        if(onClick){
            addStateHistory(`${action}-click`);
            onClick();
        }
    }

    return (
        <a href={href} style={style} className='app-link' target={target} onClick={onClickWrapper} {...rest}>
            {children}
        </a>
    );
};
